import { AMOSTRAS_SUSPENSAS } from './amostrasSuspensas';

/**
 * O lugar da amostra que não monta (ou monta num estado só) porque o
 * componente reprova no axe nesse estado: diz o defeito e a medida, em vez de
 * pintar a violação na documentação (`amostrasSuspensas.ts`).
 */
export function AmostraSuspensa({ item, medida }: { item: string; medida?: string }) {
  const suspensa = AMOSTRAS_SUSPENSAS.find((a) => a.item === item);
  if (!suspensa) throw new Error(`"${item}" não está em AMOSTRAS_SUSPENSAS`);
  return (
    <div className="w-full rounded-lg border border-dashed border-border bg-card p-3 text-xs text-muted-foreground">
      <p>
        <strong className="text-foreground">Amostra suspensa.</strong> {suspensa.defeito}
        {medida ? ` Medido de tokens.css: ${medida}.` : ''} Correção registrada, no componente (
        <code>{suspensa.arquivo}</code>), fora desta documentação.
      </p>
    </div>
  );
}
